@if(text) {
<button mat-flat-button appearance="outline" [ngClass]="[
        'text',
        color,
        size,
        textColor ? 'text-' + textColor : '',
        (disabled || loading ? ' disabled' : ''),
        noHover ? 'no-hover' : '',
        customClass ? customClass : '',
        darkColor ? 'dark-' + darkColor : ''
    ]" [type]="type" [disabled]="disabled || loading" (click)="onClick($event)" [matTooltip]="tooltip"
    [attr.aria-label]="ariaLabel || tooltip || null">

    <mat-icon *ngIf="svgIcon && !loading" [svgIcon]="svgIcon"></mat-icon>
    <mat-icon *ngIf="icon && !svgIcon && !loading">{{ icon }}</mat-icon>

    <app-spinner *ngIf="loading" [size]="20" [text]="hasProgress ? progressPercent + '%' : 'status.loading'" [textWidth]="hasProgress ? '4ch' : ''"></app-spinner>

    <span *ngIf="!loading">{{text}}</span>
</button>
}
@else {
<button mat-icon-button [ngClass]="[
        color,
        size,
        textColor ? 'text-' + textColor : '',
        (disabled || loading ? ' disabled' : ''),
        noHover ? 'no-hover' : '',
        customClass ? customClass : '',
        darkColor ? 'dark-' + darkColor : ''
    ]" [type]="type" [disabled]="disabled || loading" (click)="onClick($event)" [matTooltip]="tooltip"
    [attr.aria-label]="ariaLabel || tooltip || null">

    <mat-icon *ngIf="svgIcon && !loading" [svgIcon]="svgIcon"></mat-icon>
    <mat-icon *ngIf="icon && !svgIcon && !loading">{{ icon }}</mat-icon>

    <app-spinner *ngIf="loading" [size]="20" [iconOnly]="!hasProgress" [text]="hasProgress ? progressPercent + '%' : 'status.loading'"></app-spinner>
</button>
}